import { FaCalendarCheck, FaUserCheck, FaClock, FaMapMarkerAlt } from 'react-icons/fa';

const counter = [
    {
        id: 1,
        icon: <FaCalendarCheck />, // Calendar check icon for events held
        title: 'Game Categories',
        count: '18',
    },
    {
        id: 2,
        icon: <FaUserCheck />, // User check icon for happy attendees
        title: 'Participants',
        count: '500',
    },
    {
        id: 3,
        icon: <FaClock />, // Clock icon for years in operation
        title: 'Years in Operation',
        count: '10',
    },
    {
        id: 4,
        icon: <FaMapMarkerAlt />, // Map marker icon for cities hosted
        title: 'Country Hosted',
        count: '6',
    },
];

export default counter;